function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "chat-user-2",
  transform: "translate(1 .999)"
}, React.createElement("path", {
  id: "Path_49",
  d: "M34.923 0H14.185A5.192 5.192 0 0 0 9 5.186v2.073a1.037 1.037 0 1 0 2.074 0V5.186a3.115 3.115 0 0 1 3.111-3.111h20.738a3.115 3.115 0 0 1 3.111 3.111v10.369a3.115 3.115 0 0 1-3.111 3.111h-3.111a1.033 1.033 0 0 0-.78.355L26 24.767l.616-4.936a1.036 1.036 0 0 0-1.029-1.165h-1.033a1.037 1.037 0 0 0-.137 2.066l-.892 7.138a1.036 1.036 0 0 0 .606 1.074 1.032 1.032 0 0 0 1.2-.263l6.949-7.941h2.64a5.192 5.192 0 0 0 5.185-5.185V5.186A5.192 5.192 0 0 0 34.923 0z",
  className: "cls-1",
  transform: "translate(9.664)"
}), React.createElement("path", {
  id: "Path_50",
  d: "M32.323 34.293l-6.087-1.522-.465-1.86a11.442 11.442 0 0 0 3.092-6.126 2.663 2.663 0 0 0 1.782-2.185l.406-3.246a2.658 2.658 0 0 0-1.545-2.75l.137-2.81.552-.552c.971-1.031 1.775-2.793.112-5.336C29.044 5.977 26.912 5 23.969 5a10.935 10.935 0 0 0-6.221 1.628c-7.049.168-8.009 3.48-8.009 6.713 0 .7.158 2.2.274 3.206a2.66 2.66 0 0 0-1.661 2.8l.406 3.246a2.663 2.663 0 0 0 1.976 2.246 11.509 11.509 0 0 0 2.934 5.921l-.5 2.01-6.088 1.523A9.334 9.334 0 0 0 0 43.364a1.032 1.032 0 0 0 .3.734 1.048 1.048 0 0 0 .734.3h37.329a1.037 1.037 0 0 0 1.037-1.039 9.331 9.331 0 0 0-7.077-9.066zm-30.175 8.03A7.264 7.264 0 0 1 7.586 36.3l6.69-1.674a1.037 1.037 0 0 0 .755-.755l.8-3.183a1.038 1.038 0 0 0-.3-1.008A9.263 9.263 0 0 1 12.7 23.8a1.037 1.037 0 0 0-1.035-.954H11.4a.588.588 0 0 1-.581-.514l-.406-3.246a.577.577 0 0 1 .143-.462.734.734 0 0 1 .606-.2 1.036 1.036 0 0 0 1.029-1.165c-.1-.827-.373-3.146-.373-3.928 0-2.507.471-4.585 6.275-4.643a1.022 1.022 0 0 0 .591-.193 8.659 8.659 0 0 1 5.288-1.429c2.2 0 3.747.662 4.6 1.966.987 1.506.61 2.25.135 2.756l-.813.813a1.035 1.035 0 0 0-.3.682l-.2 4.061a1.035 1.035 0 0 0 1.022 1.087.579.579 0 0 1 .438.2.57.57 0 0 1 .139.454l-.406 3.246a.612.612 0 0 1-.662.514 1.037 1.037 0 0 0-1.035.954 9.218 9.218 0 0 1-2.966 6 1.033 1.033 0 0 0-.313 1.022l.763 3.049a1.037 1.037 0 0 0 .755.755l6.69 1.674a7.262 7.262 0 0 1 5.435 6.022z",
  className: "cls-1",
  transform: "translate(0 5.368)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 51.772,
    height: 51.767,
    viewBox: "0 0 51.772 51.767"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/chat.481fa7cd.svg";
export { SvgComponent as ReactComponent };